<template>
    <section class="blockElement fix-mt">
        <div class="customFlex-wrapper">
          <app-LeftNavigation></app-LeftNavigation>
			    <div class="rightArea border-top dashboard justify-content-center row vh_100 whiteBG pr-2 pl-0">
            <div class="col-12 p-0">
              <app-header :pageName="pageTitle" ></app-header>
              <router-view/>
            </div>
          </div> 
        </div>
    </section>
</template>
<script>
  //import WOW from '../../../static/common/js/wow.min.js'
	import LeftNavigation from './shared/left_navigation'
import { fxViewMixins } from '@/plugins/fxView'
  import * as types from '../../types'
   import moment from 'moment'
  export default {
    name: 'fxViewApp',
	mixins: [fxViewMixins],
    data() {
        return {  
          pageTitle : '',
        }
    },
	methods:{
		setData(getData){
			this.pageTitle = getData
		},
    dateFormat(dateVal){
        return moment(dateVal).format('DD-MM-YYYY, h:mm:ss a')
    }
	},
    components: {    
      appLeftNavigation: LeftNavigation,   
    },
	 created(){
		this.$store.dispatch(types.RUN_STATE_LOAD)
    } 
  }
</script>




// WEBPACK FOOTER //
// src/components/fxView/index.vue